import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* getNpcTeamEntriesEditable(action: any): any {
  try {
    yield put({ type: npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_LOADER });
    const response = yield call(npcLogService.getTeamEntriesEditable, action.payload);
    if (response?.status === 200) {
      yield put({
        type: npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_FAILURE, payload: error });
  }
}

function* getNpcTeamEntriesEditableSaga() {
  yield takeEvery(npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_REQUEST, getNpcTeamEntriesEditable);
}

export default getNpcTeamEntriesEditableSaga;
